import { useQuery } from '@tanstack/react-query'
import Challenge from '../../model/Challenge'
import { dataSource } from '../../service/domain/_service.config'

export const CHALLENGE_QUERY_KEY = (challengeID: string) => ['challenge', challengeID] as const

export function useChallenge(challengeID: string) {
  return useQuery<Challenge>({
    queryKey: CHALLENGE_QUERY_KEY(challengeID),
    queryFn: () => dataSource.getChallenge(challengeID),
    enabled: !!challengeID,
  })
}
